import { RxMembershipSignUpState } from "../RxMembershipSignUp";

export const getReferralQueryString = (
  state: RxMembershipSignUpState
): string => {
  const facilityCode = state.facilityReferral?.facilityCode;
  const producerCode = state.producerReferral?.producerCode;

  const queryParams = {
    org: facilityCode,
    pro: producerCode,
  };

  const filteredKeys = Object.keys(queryParams).filter(
    (key) => queryParams[key]
  );

  if (!filteredKeys.length) return "";

  const filteredQueryParams = filteredKeys.reduce((params, key) => {
    params[key] = queryParams[key];
    return params;
  }, {});

  return `?${new URLSearchParams(filteredQueryParams).toString()}`;
};
